import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from "bootbox";

let offerts = []
let aviso = []
export default class extends Controller {
    connect() {
        let context = this
        let user = $('#user_notification_id');
        $.ajax({
            url: `${location.origin}/admin/offerts/active`,
            data: {
                agency: user[0].dataset.userId
            },
            type: 'GET',
            success: function(data){
                if(parseInt(data.total) >= 1){
                    // offerts = data.rows
                    data.rows.map((element) => {
                        if(element.tipo === 'Aviso'){
                            aviso.push(element)
                        }
                        if(element.tipo === 'Oferta'){
                            offerts.push(element)
                        }
                    })
                    let html = ''

                    if(aviso.length > 0){
                        let avisos = document.getElementById('avisos');
                        if(avisos){
                            avisos.classList.remove('ocultar')
                            avisos.setAttribute('title',`${aviso.length} Aviso(s) Importante(s)`)
                            avisos.addEventListener('click', context.viewAvisos)
                            avisos.querySelectorAll('.bullet').forEach((bullet) => {
                                bullet.classList.remove('ocultar')
                            })
                        }
                    }
                    if(offerts.length >0){
                        html += ` <button class="offert_btn" data-action="click->activeOfferts#viewOfferts" data-tipo="ofertas">
                                                      <span class="icon" data-tipo="ofertas">
                                                          <svg xmlns="http://www.w3.org/2000/svg"
                                                               width="24"
                                                               height="24"
                                                               viewBox="0 0 24 24"
                                                               class="icon icon-tabler icon-tabler-flame flame">
                                                        
                                                          <defs>
                                                            <linearGradient id="flameGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                                              <stop offset="0%" stop-color="#f59d05"/>
                                                              <stop offset="100%" stop-color="#d43f34"/>
                                                            </linearGradient>
                                                          </defs>
                                                        
                                                            <!-- path vacío de Tabler (se mantiene) -->
                                                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                        
                                                            <!-- Ícono -->
                                                          <path
                                                            d="M10 2c0 -.88 1.056 -1.331 1.692 -.722
                                                               c1.958 1.876 3.096 5.995 1.75 9.12
                                                               l-.08 .174l.012 .003
                                                               c.625 .133 1.203 -.43 2.303 -2.173
                                                               l.14 -.224a1 1 0 0 1 1.582 -.153
                                                               c1.334 1.435 2.601 4.377 2.601 6.27
                                                               c0 4.265 -3.591 7.705 -8 7.705
                                                               s-8 -3.44 -8 -7.706
                                                               c0 -2.252 1.022 -4.716 2.632 -6.301
                                                               l.605 -.589c.241 -.236 .434 -.43 .618 -.624
                                                               c1.43 -1.512 2.145 -2.924 2.145 -4.78"
                                                            fill="url(#flameGradient)"
                                                            stroke="url(#flameGradient)"
                                                            stroke-width="0.50"
                                                            stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                      </span >
                                                    <span class="text">
                                                    Ofertas
                                                     <i class="indicator">${offerts.length}</i>
                                                    </span>
                                                  </button>`
                    }
                    context.element.innerHTML = html
                }
            }
        })
    }

    viewOfferts(){

        let carouselItems = ''
        let button_actions = ''
        if (offerts.length > 1){
            button_actions = ` <button class="carousel-control-prev" type="button" data-target="#offerts_carousel" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true">
                                </span>
                              </button>
                              <button class="carousel-control-next" type="button" data-target="#offerts_carousel" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true">
                                </span>
                              </button>`
        }
        offerts.map((element,index) => {
            let active = index === 0 ? 'active' : '';
            let descripcion = element.to.split(' ')[0]
            carouselItems += `<div class="carousel-item ${active}">
                              <img src="${element.image}" class="d-block w-100" alt="Daiquiri ${element.tipo} ${index + 1}">
                              <div class="text-offert" style="color: #1e2229; margin-top: 5px;">
                                <h5>${element.tipo} #${index + 1} | <span style="font-size: .8rem; background: #d43f34;padding: 5px 10px;color: white;">Válida hasta ${descripcion}</span></h5>
                                <p>${element.descripcion}</p>
                              </div>
                            </div>`
        })

        bootbox.dialog({
            message: `<div id="offerts_carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="false">
                      <div class="carousel-inner">
                        ${carouselItems}
                      </div>
                     ${button_actions}
                    </div>`,
            buttons: {
                ok: {
                    label: 'Leído',
                    callback: function (e) {
                    }
                }
            }
        })

    }
    viewAvisos(){
        let carouselItems = ''
        let button_actions = ''
        if (aviso.length > 1){
            button_actions = ` <button class="carousel-control-prev" type="button" data-target="#offerts_carousel" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true">
                                </span>
                              </button>
                              <button class="carousel-control-next" type="button" data-target="#offerts_carousel" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true">
                                </span>
                              </button>`
        }
        aviso.map((element,index) => {
            let active = index === 0 ? 'active' : '';
            let descripcion = element.from.split(' ')[0]
            carouselItems += `<div class="carousel-item ${active}">
                              <img src="${element.image}" class="d-block w-100" alt="Daiquiri ${element.tipo} ${index + 1}">
                              <div class="text-offert" style="color: #1e2229; margin-top: 5px;">
                                <h5>${element.tipo} #${index + 1} | <span style="font-size: .8rem; background: #d43f34;padding: 5px 10px;color: white;"> A partir de ${descripcion}</span></h5>
                                <p>${element.descripcion}</p>
                              </div>
                            </div>`
        })

        bootbox.dialog({
            message: `<div id="offerts_carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="false">
  <div class="carousel-inner">
    ${carouselItems}
  </div>
 ${button_actions}
</div>`,
            buttons: {
                ok: {
                    label: 'Leído',
                    callback: function (e) {
                    }
                }
            }
        })

    }
}